import { createInternalNeonAuth } from '@neondatabase/neon-js/auth'
const client = createInternalNeonAuth(import.meta.env.VITE_NEON_AUTH_URL, {allowAnonymous:false})
export const auth = client.adapter
export const getAccessToken = () => client.getJWTToken()
